"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _propTypes2 = require("../helpers/prop-types");
var _reactVis = require("react-vis");
var _empty = require("./empty");
var _colors = require("../helpers/colors");
require("react-vis/dist/style.css");
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultColorScale = (0, _colors.colorScaleCategorical)();
var DEFAULT_BAR_WIDTH_RATIO = 0.8;
var GroupedBarChart = /*#__PURE__*/function (_Component) {
  _inherits(GroupedBarChart, _Component);
  var _super = _createSuper(GroupedBarChart);
  function GroupedBarChart() {
    var _this;
    _classCallCheck(this, GroupedBarChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hoveredValue: undefined
    });
    _defineProperty(_assertThisInitialized(_this), "_processData", function () {
      var _this$props = _this.props,
        data = _this$props.data,
        orientation = _this$props.orientation;
      var hoveredValue = _this.state.hoveredValue;
      var bars = data.map(function (d) {
        return {
          k: d.k,
          v: d.v.map(function (d2) {
            var group = d.k;
            var x = orientation === "vertical" ? d2.v : d2.k;
            var y = orientation === "vertical" ? d2.k : d2.v;
            var key = orientation === "vertical" ? y : x;
            var value = orientation === "vertical" ? x : y;
            var opacity = hoveredValue && hoveredValue.key !== key ? 0.2 : 1;
            return {
              group: group,
              x: x,
              y: y,
              key: key,
              value: value,
              opacity: opacity
            };
          })
        };
      });
      return orientation === "vertical" ? bars.reverse() : bars;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTooltip", function (values) {
      var _this$props2 = _this.props,
        tooltipValueFormat = _this$props2.tooltipValueFormat,
        tooltipExtraRow = _this$props2.tooltipExtraRow,
        tooltipRenderer = _this$props2.tooltipRenderer;
      var hoveredValue = _this.state.hoveredValue;
      var tooltipValues = hoveredValue !== undefined ? values.map(function (series) {
        return series.v.filter(function (item) {
          return item.key === hoveredValue.key;
        })[0];
      }).filter(function (e) {
        return e;
      }) : [];
      return hoveredValue ? /*#__PURE__*/_react.default.createElement(_reactVis.Hint, {
        value: hoveredValue
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rv-hint__content"
      }, _this.props.tooltipRenderer ? tooltipRenderer(tooltipValues) : /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: 3
      }, /*#__PURE__*/_react.default.createElement("strong", null, tooltipValues[0].key)))), /*#__PURE__*/_react.default.createElement("tbody", null, tooltipValues.map(function (val, i) {
        return val ? /*#__PURE__*/_react.default.createElement("tr", {
          key: i
        }, /*#__PURE__*/_react.default.createElement("td", null, val.group), /*#__PURE__*/_react.default.createElement("td", null, tooltipValueFormat(val.value))) : null;
      })), tooltipExtraRow && /*#__PURE__*/_react.default.createElement("tfoot", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: 3
      }, (0, _isFunction.default)(tooltipExtraRow) ? tooltipExtraRow(tooltipValues) : tooltipExtraRow)))))) : null;
    });
    _defineProperty(_assertThisInitialized(_this), "_updateTooltip", function (val) {
      _this.setState({
        hoveredValue: val
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_clearTooltip", function () {
      _this.setState({
        hoveredValue: undefined
      });
    });
    return _this;
  }
  _createClass(GroupedBarChart, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        width = _this$props3.width,
        height = _this$props3.height,
        margin = _this$props3.margin,
        colorMap = _this$props3.colorMap,
        domainX = _this$props3.domainX,
        domainY = _this$props3.domainY,
        showAxisX = _this$props3.showAxisX,
        showAxisY = _this$props3.showAxisY,
        axisTitleX = _this$props3.axisTitleX,
        axisTitleY = _this$props3.axisTitleY,
        orientation = _this$props3.orientation,
        tickLabelAngleX = _this$props3.tickLabelAngleX,
        tickLabelAngleY = _this$props3.tickLabelAngleY,
        tickFormatX = _this$props3.tickFormatX,
        tickFormatY = _this$props3.tickFormatY,
        onValueClick = _this$props3.onValueClick,
        tickTotalX = _this$props3.tickTotalX,
        tickTotalY = _this$props3.tickTotalY,
        showGridLines = _this$props3.showGridLines,
        barWidthRatio = _this$props3.barWidthRatio;
      var bars = this._processData();
      var _valueClick = onValueClick ? onValueClick : null;
      var barSeriesStyle = onValueClick ? {
        "cursor": "pointer"
      } : undefined;
      var getBarSeriesColor = function getBarSeriesColor(d) {
        return colorMap ? colorMap[d] : defaultColorScale(d);
      };
      // sanitize barWidthRatio
      var barWidth = typeof barWidthRatio === 'number' && barWidthRatio >= 0 && barWidthRatio <= 1 ? barWidthRatio : DEFAULT_BAR_WIDTH_RATIO;
      return orientation === "vertical" ? /*#__PURE__*/_react.default.createElement(_reactVis.XYPlot, {
        yType: "ordinal",
        width: width,
        height: height,
        margin: margin,
        xDomain: domainX,
        yDomain: domainY
      }, showGridLines ? /*#__PURE__*/_react.default.createElement(_reactVis.VerticalGridLines, null) : null, bars.map(function (bar, i) {
        return /*#__PURE__*/_react.default.createElement(_reactVis.HorizontalBarSeries, {
          cluster: bar.k,
          data: bar.v,
          onSeriesMouseOut: _this2._clearTooltip,
          onValueMouseOver: _this2._updateTooltip,
          onValueClick: _valueClick,
          style: barSeriesStyle,
          barWidth: barWidth,
          key: i,
          color: getBarSeriesColor(bar.k),
          colorType: "literal"
        });
      }), showAxisX ? /*#__PURE__*/_react.default.createElement(_reactVis.XAxis, {
        title: axisTitleX,
        tickLabelAngle: tickLabelAngleX,
        tickTotal: tickTotalX,
        tickFormat: function tickFormat(t, i) {
          return tickFormatX(t, i);
        },
        orientation: "top"
      }) : null, showAxisY ? /*#__PURE__*/_react.default.createElement(_reactVis.YAxis, {
        title: axisTitleY,
        tickLabelAngle: tickLabelAngleY,
        tickTotal: tickTotalY,
        tickFormat: function tickFormat(t, i) {
          return tickFormatY(t, i);
        }
      }) : null, this._renderTooltip(bars)) : /*#__PURE__*/_react.default.createElement(_reactVis.XYPlot, {
        xType: "ordinal",
        width: width,
        height: height,
        margin: margin,
        xDomain: domainX,
        yDomain: domainY
      }, showGridLines ? /*#__PURE__*/_react.default.createElement(_reactVis.HorizontalGridLines, null) : null, bars.map(function (bar, i) {
        return /*#__PURE__*/_react.default.createElement(_reactVis.VerticalBarSeries, {
          cluster: bar.k,
          data: bar.v,
          onSeriesMouseOut: _this2._clearTooltip,
          onValueMouseOver: _this2._updateTooltip,
          onValueClick: _valueClick,
          style: barSeriesStyle,
          barWidth: barWidth,
          key: i,
          color: getBarSeriesColor(bar.k),
          colorType: "literal"
        });
      }), showAxisX ? /*#__PURE__*/_react.default.createElement(_reactVis.XAxis, {
        title: axisTitleX,
        tickLabelAngle: tickLabelAngleX,
        tickTotal: tickTotalX,
        tickFormat: function tickFormat(t, i) {
          return tickFormatX(t, i);
        }
      }) : null, showAxisY ? /*#__PURE__*/_react.default.createElement(_reactVis.YAxis, {
        title: axisTitleY,
        tickLabelAngle: tickLabelAngleY,
        tickTotal: tickTotalY,
        tickFormat: function tickFormat(t, i) {
          return tickFormatY(t, i);
        }
      }) : null, this._renderTooltip(bars));
    }
  }]);
  return GroupedBarChart;
}(_react.Component);
_defineProperty(GroupedBarChart, "propTypes", {
  data: _propTypes2.propTypeGroupedSeries.isRequired,
  colorMap: _propTypes.default.object,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  margin: _propTypes2.propTypeMargin,
  orientation: _propTypes.default.oneOf(["horizontal", "vertical"]),
  showGridLines: _propTypes.default.bool,
  barWidthRatio: _propTypes.default.number,
  // [0,1], 1:bars touch each other, 0:bars are invisible
  tickLabelAngleX: _propTypes.default.number,
  tickLabelAngleY: _propTypes.default.number,
  tickFormatX: _propTypes.default.func,
  tickFormatY: _propTypes.default.func,
  tickTotalX: _propTypes.default.number,
  tickTotalY: _propTypes.default.number,
  domainX: _propTypes.default.array,
  domainY: _propTypes.default.array,
  showAxisX: _propTypes.default.bool,
  showAxisY: _propTypes.default.bool,
  axisTitleX: _propTypes.default.string,
  axisTitleY: _propTypes.default.string,
  tooltipValueFormat: _propTypes.default.func,
  tooltipExtraRow: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.func]),
  tooltipRenderer: _propTypes.default.func,
  onValueClick: _propTypes.default.func
});
_defineProperty(GroupedBarChart, "defaultProps", {
  width: 600,
  height: 300,
  margin: {
    left: 50,
    right: 50,
    top: 50,
    bottom: 50
  },
  orientation: "horizontal",
  showGridLines: true,
  barWidthRatio: DEFAULT_BAR_WIDTH_RATIO,
  tickLabelAngleX: 0,
  tickLabelAngleY: 0,
  showAxisX: true,
  showAxisY: true,
  tickFormatX: function tickFormatX(t) {
    return t;
  },
  tickFormatY: function tickFormatY(t) {
    return t;
  },
  tooltipValueFormat: function tooltipValueFormat(v) {
    return v;
  },
  onValueClick: null
});
var _default = (0, _empty.withEmptyView)(GroupedBarChart);
exports.default = _default;